import { render, staticRenderFns } from "./SmsConversationWindow.vue?vue&type=template&id=57c55612&scoped=true&"
import script from "./SmsConversationWindow.vue?vue&type=script&lang=js&"
export * from "./SmsConversationWindow.vue?vue&type=script&lang=js&"
import style0 from "./scoped.scss?vue&type=style&index=0&id=57c55612&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c55612",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Flocal%2Fbamboo-home%2Flocal-working-dir%2F56885249%2FEIPSMS-UB-DB%2Fsrc%2Fcomponents%2FSmsConversationWindow%2FSmsConversationWindow.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports